import * as Sentry from '@sentry/react';

const SENTRY_ENABLED =
  !!import.meta.env.VITE_SENTRY_WEB_DSN?.length && import.meta.env.VITE_SENTRY_ENABLED === 'true';

const initSentry = () => {
  if (!SENTRY_ENABLED) {
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_WEB_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // TODO: These are defaults, and may not work with our basic Sentry plan
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // TODO: Does this need port #s specified for both web and api?
    tracePropagationTargets: ['localhost'],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};

export default initSentry;
